import TitleComponent from "components/TitleComponent";
import type { IPage } from "InterfacesTypes/interfaces";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentNews } from "state/selectors/Selectors";
import { getEnvironment, truncateText } from "utils/utils";

const CurrentNews = () => {
  const env = getEnvironment();

  const currentNewsItems = useSelector(selectCurrentNews);
  function extractParagraphs(html: string) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const paragraphs = [...doc.querySelectorAll("p")];
    return paragraphs.map((p) => p.innerHTML).join(" ");
  }
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] =
    useState<IPage | null>(null);
  const openDrawer = (notification: IPage) => {
    setSelectedNotification(notification);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedNotification(null);
  };

  return (
    <div className="!h-[75%] relative">
      <TitleComponent
        title={
          <a
            href="/tjansterprodukter/Nyhetsarkiv/SitePages/Home.aspx"
            className="!no-underline hover:!underline !bg-transparent hover:!bg-transparent"
          >
            Aktuellt
          </a>
        }
      />

      {/* LIST */}
      <ul className="!px-3 !mt-6">
        {currentNewsItems.map((notification, i) => (
          <li
            key={i}
            className="!mb-4 hover:scale-105 transition-transform duration-600 border-b-2 border-[#007167]"
          >
            <button
              type="button"
              onClick={() => openDrawer(notification)}
              className="w-full !border-none text-left flex items-start gap-2 !py-1 hover:bg-gray-50 !rounded-lg transition hover:!bg-white"
            >
              <img
                src={notification?.BannerImageUrl?.Url}
                className="!w-27 !h-38 flex-none !object-cover"
                alt="News Image"
              />
              <div className="!min-w-0 flex-1">
                <p className="text-lg text-start font-semibold !text-[rgb(44,43,43)] !mb-[0.5rem] leading-snug line-clamp-2 hover:!no-underline">
                  {notification.Title}
                </p>
                <p
                  className="font-normal text-sm text-start !text-gray-600 leading-snug line-clamp-5 hover:!no-underline "
                  dangerouslySetInnerHTML={{
                    __html: truncateText(
                      extractParagraphs(notification.CanvasContent1) ??
                      notification.WikiField ??
                      "",
                      100
                    ),
                  }}
                ></p>
              </div>
              <svg
                className="!m-2 h-5 w-5 flex-none text-gray-600"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707A1 1 0 118.707 5.293l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </li>
        ))}
      </ul>

      {/* DRAWER */}
      {isDrawerOpen && selectedNotification && (
        <>
          <div className="fixed inset-0 z-50 bg-white" onClick={closeDrawer} />
          <div className={`
              absolute 
              top-0 
              left-[-1%] 
              [@media(min-width:700px)]:left-[100%] 
              !ml-1 
              rounded-[10px]
              [@media(min-width:700px)]:rounded-tr-[10px]
              [@media(min-width:700px)]:rounded-br-[10px] 
              [@media(min-width:700px)]:rounded-tl-[0px]
              [@media(min-width:700px)]:rounded-bl-[0px]
              z-50 
              [@media(min-width:700px)]:w-[110%]
              w-[101%]
              h-[130%] 
              [@media(min-width:700px)]:h-[110%] 
              !bg-[rgba(33,37,41,1)] 
              shadow-xl 
              border-l 
              border-gray-200 
              flex 
              flex-col
            `}>
            <div className="flex items-center rounded-tr-[10px] rounded-tl-[10px] [@media(min-width:700px)]:rounded-tr-[10px] [@media(min-width:700px)]:rounded-tl-[0px] px-4 py-2 border-b border-gray-200 bg-[rgba(33,37,41,1)] !text-white">
              <h4 className="truncate text-xl m-0 font-semibold !flex-1">
                {selectedNotification.Title}
              </h4>
              <button
                type="button"
                onClick={closeDrawer}
                className="!min-w-0 rounded-full !text-white !bg-transparent hover:bg-white !text-2xl focus:outline-none !border-none hover:!bg-transparent"
                aria-label="Stäng"
              >
                ✕
              </button>
            </div>
            <div className="p-4 overflow-y-auto space-y-3">
              {selectedNotification.BannerImageUrl?.Url && (
                <img
                  src={selectedNotification.BannerImageUrl?.Url}
                  alt="News Image"
                  className="w-full max-h-56 object-cover rounded-md"
                />
              )}
              <p
                className="text-base !text-white whitespace-pre-line"
                dangerouslySetInnerHTML={{
                  __html: truncateText(
                    extractParagraphs(selectedNotification.CanvasContent1) ??
                    selectedNotification.WikiField ??
                    "",
                    280
                  ),
                }}
              ></p>
              <a
                href={`${env.imageUrl}${selectedNotification.FileRef}`}
                className="flex justify-end !bg-transparent !no-underline !text-white hover:!underline"
              >
                Läs mer...
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default CurrentNews;
